import React from 'react'
import styles from './style'
import propTypes from './prop'
import { Grid, withStyles, Box } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'

const InputEntry = props => {
  const { classes } = props

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Grid item className={classes.grid}>
        <CoreTextField label={"Learners' answer area"} disabled fullWidth />
      </Grid>
    </Grid>
  )
}

InputEntry.propTypes = propTypes

export default withStyles(styles)(InputEntry)
